
// Action: file_editor create /app/frontend/src/components/Testimonials.js --file-text 
import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { testimonialsData } from '../data/testimonials';

const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="font-manrope text-sm tracking-widest uppercase text-[#D4AF37] mb-4">
            Testimonials
          </p>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6 tracking-tight">
            What Our <span className="italic">Clients Say</span>
          </h2>
          <p className="font-manrope text-base md:text-lg text-[#666666] max-w-2xl mx-auto">
            Don't just take our word for it. Hear from our satisfied clients about 
            their experience working with us.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonialsData.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              data-testid={`testimonial-card-${testimonial.id}`}
              className="bg-white p-8 rounded-sm shadow-sm hover:shadow-xl transition-shadow duration-300 group"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <Quote size={40} className="text-[#D4AF37]/20 group-hover:text-[#D4AF37]/40 transition-colors duration-300" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4" data-testid={`testimonial-rating-${testimonial.id}`}>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={18}
                    className="fill-[#D4AF37] text-[#D4AF37]"
                  />
                ))}
              </div>

              {/* Message */}
              <p className="font-manrope text-[#666666] leading-relaxed mb-6">
                "{testimonial.message}"
              </p>

              {/* Client Info */}
              <div className="border-t border-gray-200 pt-4">
                <h4 className="font-playfair text-lg font-semibold text-[#1A1A1A] mb-1">
                  {testimonial.name}
                </h4>
                <p className="font-manrope text-sm text-[#D4AF37]">
                  {testimonial.project}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <div className="inline-block bg-white p-12 rounded-sm shadow-lg">
            <h3 className="font-playfair text-3xl font-bold text-[#1A1A1A] mb-4">
              Ready to Transform Your Space?
            </h3>
            <p className="font-manrope text-[#666666] mb-6 max-w-xl">
              Join our growing list of satisfied clients and experience the 
              difference of working with true professionals.
            </p>
            <a
              href="/contact"
              data-testid="testimonials-cta-button"
              className="inline-block bg-[#D4AF37] text-[#1A1A1A] px-8 py-4 rounded-full font-manrope font-medium hover:bg-[#1A1A1A] hover:text-white transition-all duration-300"
            >
              Get Started Today
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
// Observation: Create successful: /app/frontend/src/components/Testimonials.js